import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, PopoverController, LoadingController, AlertController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';

/**
 * Generated class for the ReporteClientesInactivosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reporte-clientes-inactivos',
  templateUrl: 'reporte-clientes-inactivos.html',
})
export class ReporteClientesInactivosPage {
  clientes: any = []
  clientesres: any = []
  aux: any = []
  busqueda: any
  actSearch: any = false
  skip: any = 0
  super: any = false
  vendedor: any = ''
  loadModal: any
  url: any
  total: any = 0
  faltante: any = 0
  police: any = false
  constructor(
    public navCtrl: NavController,
    public http: HttpProvider,
    public loadingCtrl: LoadingController,
    public alertCrtl: AlertController,
    public modalSrv: ModalController,
    public popCtrl: PopoverController,
    public navParams: NavParams
    ) {
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  ionViewDidEnter() {
    if(window.localStorage.getItem('super')){
      this.super = true
    }else{
      this.vendedor = window.localStorage.getItem('co_ven')
    }
    this.url = (this.super) ? `pedidosCom/cli/inactivo?skip=${this.skip}&vendedores=${window.localStorage.getItem('vendedores')}` : `pedidosCom/cli/inactivo?vendedor=${this.vendedor}&skip=${this.skip}`
    this.buscarClientes(this.url, false, false)
  }

  buscarClientes(url, infinite, search) {
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.get(url).subscribe(
        (res: any) => {
          this.total = res.total
          this.faltante = res.faltante
          if (search) {
            if (infinite) {
              this.clientes = this.clientes.concat(res.data)
            } else {
              this.clientes = res.data
            }
          } else {
            if (infinite) {
              this.clientes = this.clientes.concat(res.data)
            } else {
              this.clientes = res.data
            }
          }
          if (res && res.data.length > 0) this.police = false
          this.skip += 10
          this.DesactivarLoading()
        }, 
        err => {
          this.police = false
          this.DesactivarLoading()
          console.log(err)
        }
      )
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  buscar(){
    this.skip = 0
    this.clientesres = this.clientes.slice(0, 9)
    this.clientes = []
    this.url = (this.super) ? `pedidosCom/cli/inactivo?skip=${this.skip}&search=${this.busqueda}&vendedores=${window.localStorage.getItem('vendedores')}` : `pedidosCom/cli/inactivo?vendedor=${this.vendedor}&skip=${this.skip}&search=${this.busqueda}`
    this.actSearch = true
    this.buscarClientes(this.url, false, true)
  }

  reset(){
    if(this.busqueda.length === 0) {
      this.clientes = this.clientesres.slice()
      this.clientesres = []
      this.actSearch = false
      this.skip = 10
    }
  }

  doInfinite(infiniteScroll){
    if(window.localStorage.getItem('network') === '1') {
      if (!this.police) {
        this.police = true
        if (!this.actSearch) {
          this.url = (this.super) ? `pedidosCom/cli/inactivo?skip=${this.skip}&vendedores=${window.localStorage.getItem('vendedores')}` : `pedidosCom/cli/inactivo?vendedor=${this.vendedor}&skip=${this.skip}`
          this.buscarClientes(this.url, true, false)
        } else {
          this.url = (this.super) ? `pedidosCom/cli/inactivo?skip=${this.skip}&search=${this.busqueda}&vendedores=${window.localStorage.getItem('vendedores')}` : `pedidosCom/cli/inactivo?vendedor=${this.vendedor}&skip=${this.skip}&search=${this.busqueda}`
          this.buscarClientes(this.url, true, true)
        }
      }
    }
    infiniteScroll.complete()
  }

}



// WEBPACK FOOTER //
// ./src/pages/reporte-clientes-inactivos/reporte-clientes-inactivos.ts